import VideoPlayerMetaMore from './VideoPlayerMetaMore'

export default VideoPlayerMetaMore
// eslint-disable-next-line import/export
export * from './VideoPlayerMetaMore'
